import { CalendarDatasource } from "./calendar-datasource";
import { Utility } from "../libs/utility";
import { CalendarResponseEntryDto } from "../dtos/calendar-response-entry-dto";
import {ScrollSmoothTo} from "../libs/scroll-smooth-to";
import {Utils} from "../utils";
import {FilterBarDock} from "../filter-bar-dock";
import {ResizeHelper} from "../helpers/resize-helper";
import { CalendarWidget } from "./calendar-widget";
import * as moment from 'moment';

export class CalendarScheduleDatasource implements CalendarDatasource {

	shouldRenderDetails = false;

	reload: () => void;

	calendarRendered(): void {
		this.initFilter(this.locations);
	}

	async loadMonth(year: number, month: number): Promise<boolean> {
		this.updateDownloadLink(year, month);
		return true;
	}

	getFirstDate(): Date {
		return this.firstDate;
	}
	getLastDate(): Date {
		return this.lastDate;
	}

	hasEvent(date: Date): boolean {
		//return this.datesWithEvents[Utility.getDateUtcKey(date)] === true;
		const key = Utility.getDateUtcKey(date);
		const upperBound = Utility.upperOrEqualBound(this.orderedDates, key);

		if(upperBound != null) {
			return upperBound == key;
		}

		return false;
	}

	getEventDetails(dateKey: string): CalendarResponseEntryDto[] {
		throw "Not supported";
	}

	private root: HTMLElement;
	private orderedDates: string[];
	private firstDate: Date;
	private lastDate: Date;

	constructor(rootElementId: string, private locations:string[]) {

		const now = new Date();

		this.firstDate = this.lastDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));

		const root = document.getElementById(rootElementId);
		if(root == null) {
			throw "Root not found";
		}
		this.root = root;

		//this.scan();
	}

	private scan() {
		const entries = this.root.getElementsByClassName("_entry");

		this.orderedDates = [];

		for(let i = 0; i < entries.length; ++i) {

			const entry = entries[i] as HTMLElement;

			if(entry.style.display == "none") {
				continue;
			}

			const attributeValue = entry.getAttribute("data-date");

			if(attributeValue == null) {
				continue;
			}

			const dateLocal = moment(attributeValue).toDate();
			const date = new Date(Date.UTC(dateLocal.getFullYear(), dateLocal.getMonth(), dateLocal.getDate()));

			if(this.firstDate == null || this.firstDate > date) {
				this.firstDate = date;
			}

			if(this.lastDate == null || this.lastDate < date) {
				this.lastDate = date;
			}

			const key = Utility.getDateUtcKey(date);

			this.orderedDates.push(key);
		}

		if(this.reload) {
			this.reload();
		}
	}

	private existsDate(key: string): boolean {
		const upperBound = Utility.upperOrEqualBound(this.orderedDates, key);

		if(upperBound != null) {
			return upperBound == key;
		}

		return false;
	}
	
	onDateClick(dateKey: string): void {
		if(this.orderedDates.length == 0) {
			return;
		}

		let upperBound = Utility.upperOrEqualBound(this.orderedDates, dateKey);

		if(upperBound == null) {
			upperBound = this.orderedDates[this.orderedDates.length - 1];
		}

		var target = document.getElementsByName("day-" + upperBound);
		if(target.length == 0) {
			return;
		}
		let dayHeader = target[0].nextElementSibling as HTMLElement;
		let scrollPos = dayHeader.offsetTop;
		scrollPos -= Utils.menuHeight;
		ScrollSmoothTo.run(scrollPos);
	}

	async onSelectMonth(year: number, month: number): Promise<void> {

		const target = document.getElementsByName(`month-${year}-${Utility.padNumber2(month)}`);

		if(target.length == 0) {
			return;
		}

		CalendarWidget.setSyncState(false);
		
		let monthHeader = target[0].nextElementSibling as HTMLElement;
		let scrollPos = monthHeader.offsetTop + monthHeader.offsetHeight;
		scrollPos -= Utils.menuHeight;
		window.scrollTo(0, scrollPos);

		CalendarWidget.setSyncState(true);
	}

	//////////////////////////////////////////////////////////////
	///SECTION Download
	//////////////////////////////////////////////////////////////

	private updateDownloadLink(year: number, month: number) {
		//console.log(`${year} ${month}`)
	}

	//////////////////////////////////////////////////////////////
	///SECTION Filter
	//////////////////////////////////////////////////////////////

	private dockYPos: number;
	private selectedFilterType:string;
	private selectedFilterLocation:string;

	private calenderElement:HTMLElement;
	private printScheduleElement:HTMLElement;
	private firstElementAfter:HTMLElement | null;
	private filterBar: HTMLElement;
	private calenderWidth:number;
	private resizeHelper: ResizeHelper;
	private footer:HTMLElement;
	private calenderOffsetHeight: number;
	private isDockedBottom = false;


	private initFilter(locations: string[],shouldFilter = true) {

		this.footer = <HTMLElement>document.getElementById("footer");
		if(shouldFilter){
			this.onHashChanged();
		}
		window.addEventListener("hashchange", () =>this.onHashChanged(), false);

		this.filterBar = <HTMLElement>document.getElementById("filterBar");

		this.resizeHelper = new ResizeHelper(() => this.resizeFinished());
		this.isDockedBottom = false;


		this.calenderElement = <HTMLElement>document.getElementById("p_schedule_calendar");
		this.calenderElement.classList.remove("_docked");

		let scheduleRight = document.getElementById("p_schedule_right") as HTMLElement;

		this.printScheduleElement = <HTMLElement>scheduleRight.getElementsByClassName('_printSchedule')[0];
		this.printScheduleElement.classList.remove("_docked");

		if(scheduleRight){
			this.calenderWidth = scheduleRight.offsetWidth - 43;
		}else{
			this.calenderWidth = this.calenderElement.offsetWidth - 43;
		}
		this.dockYPos = this.calenderElement.offsetTop - Utils.menuHeight - 12;

		this.firstElementAfter = this.printScheduleElement.nextSibling as HTMLElement;

		window.addEventListener("scroll",() => this.onScroll());
		this.calenderOffsetHeight = this.calenderElement.offsetHeight + this.calenderElement.offsetTop;
		this.onScroll();
		var filterBarMonth = <HTMLElement>(<HTMLElement>document.getElementById("filterBar")).getElementsByClassName("_monthHeader").item(0);
		FilterBarDock.initOnLoaded( filterBarMonth,(firstParam:any,secondParam:any) => this.filterChangedCallback(firstParam,secondParam));
		FilterBarDock.devider =  document.getElementsByClassName("_monthHeader");
		(<HTMLElement>FilterBarDock.devider.item(1)).style.display = "none";
		FilterBarDock.setFilterBarDate((<HTMLElement>FilterBarDock.devider.item(1)).innerHTML)
		FilterBarDock.checkDeviderForFilterBar();
	}

	private checkLocation(element:HTMLElement):boolean{
		if(this.selectedFilterLocation === "ANDERE"){
			var isOther = true;
			for(var i = 0; i < this.locations.length; i++){
				if(element.dataset.location === this.locations[i]){
					isOther = false;
				}
			}
			return isOther;
		}else{
			if(element.dataset.location === this.selectedFilterLocation){
				return true;
			}else{
				return false;
			}
		}
	}
	
	private onHashChanged(){
		var prefilter:any = window.location.hash.replace("#", "");
		let possibleFilter = document.getElementsByClassName("_filterListSeason").item(0).children;
		let isFilter = false;
		for(let i = 0; i < possibleFilter.length; i++){
			if(possibleFilter.item(i).innerHTML.replace(/ /g,'').toLowerCase() === prefilter.replace(/ /g,'').toLowerCase() || prefilter === "Alle" || prefilter.length === 0){
				isFilter = true;
			}
		}
		
		if(prefilter.length > 0){
			if(prefilter === "Alle"){
				prefilter = undefined;
			}
			this.selectedFilterType = prefilter;
		}
		if(isFilter){
			this.filter();
			FilterBarDock.setFirstFilter(this.selectedFilterType);
		}
	}

	private resizeFinished(){
		this.initFilter(this.locations,false);
		this.filter();
	}

	private onScroll(){
		const isDocked = this.calenderElement.classList.contains("_docked");
		const shouldBeDocked = window.pageYOffset >= this.dockYPos;

		if(isDocked){
			var positionCalender = this.calenderOffsetHeight + window.pageYOffset - 140;
			var positionFooter = this.footer.offsetTop;
			var calenderBottomPosition = window.innerHeight + window.pageYOffset - this.footer.offsetTop + 10;
			if(positionCalender >= positionFooter) {
				this.calenderElement.style.bottom = calenderBottomPosition + "px";
				this.calenderElement.style.top = "auto";
				this.printScheduleElement.style.bottom = calenderBottomPosition + "px";
				this.printScheduleElement.style.top = "auto";
				this.isDockedBottom = true;
			}else{
				this.calenderElement.style.bottom = "auto";
				this.calenderElement.style.top = null;
				this.printScheduleElement.style.bottom = "auto";
				this.printScheduleElement.style.top = null;
				this.isDockedBottom = false;
			}
		}
		if(isDocked){
			this.calenderElement.style.width = this.calenderWidth + "px";
			this.printScheduleElement.style.width = 42 + this.calenderWidth + "px";
		}else{
			this.calenderElement.style.width = null;
			this.printScheduleElement.style.width = null;
		}


		if(isDocked == shouldBeDocked) {
			return;
		}

		if(!this.isDockedBottom){
			this.calenderElement.classList.toggle("_docked");
			this.printScheduleElement.classList.toggle("_docked");
		}

		if(!isDocked){
			if(this.firstElementAfter) {
                this.firstElementAfter.style.marginTop = (this.calenderElement.offsetHeight + this.filterBar.offsetHeight + this.printScheduleElement.offsetHeight)+ "px";
            }

			this.calenderElement.style.width = this.calenderWidth + "px";
			this.printScheduleElement.style.width = 42 + this.calenderWidth + "px";
		}else{
			if(this.firstElementAfter) {
                this.firstElementAfter!.style.marginTop =  null;
            }

			this.calenderElement.style.width = null;
			this.printScheduleElement.style.width = null;
		}
	}

	private filterChangedCallback(firstParam:any,secondParam:any){
		if(firstParam !== null){
			if(firstParam === 'all'){
				firstParam = undefined;
			}
			this.selectedFilterLocation = firstParam;
		}

		if(secondParam !== null){
			if(secondParam === 'all'){
				secondParam = undefined;
			}
			this.selectedFilterType = secondParam;
		}

		this.filter();
	}

	private filter(){
		var entries = document.getElementsByClassName("_entry");
		let selectedType = undefined;
		if(this.selectedFilterType !== undefined){
			selectedType = this.selectedFilterType.replace(/ /g,'').toLowerCase();
		}
		for(var i = 0; i < entries.length; i++){
			let type = undefined;
			let tempType = (<HTMLElement>entries.item(i)).dataset.type;
			if(tempType !== undefined){
				type = tempType.replace(/ /g,'').toLowerCase();
			}
			if(type === selectedType && this.checkLocation(<HTMLElement>entries.item(i))){
				if(Utils.isPhone()){
					(<HTMLElement>entries.item(i)).style.display = "block";
				}else{
					(<HTMLElement>entries.item(i)).style.display = "flex";
				}
			}else if(selectedType === undefined && this.selectedFilterLocation === undefined){
				if(Utils.isPhone()){
					(<HTMLElement>entries.item(i)).style.display = "block";
				}else{
					(<HTMLElement>entries.item(i)).style.display = "flex";
				}
			}else if(type === selectedType && this.selectedFilterLocation === undefined){
				if(Utils.isPhone()){
					(<HTMLElement>entries.item(i)).style.display = "block";
				}else{
					(<HTMLElement>entries.item(i)).style.display = "flex";
				}
			}else if(selectedType === undefined && this.checkLocation(<HTMLElement>entries.item(i))){
				if(Utils.isPhone()){
					(<HTMLElement>entries.item(i)).style.display = "block";
				}else{
					(<HTMLElement>entries.item(i)).style.display = "flex";
				}
			}else{
				(<HTMLElement>entries.item(i)).style.display = "none";
			}		
		}
		this.checkEmptyMonths();
		this.checkDisplayDay();
		this.scan();
	}

	private checkDisplayDay(){
		this.removeNoDate();
		let listContainer = <HTMLElement>document.getElementById("p_schedule_left");
		if(listContainer == null){
			return;
		}
		let lastDate:string|undefined;
		for(let i = 0; i < listContainer.childElementCount; i++){
			let currentDate:string|undefined;
			let currentElement = <HTMLElement>listContainer.children.item(i);
			if(currentElement.classList.contains("_entry") && currentElement.style.display !== "none"){
				currentDate = currentElement.dataset.date;
			}else{
				currentDate = undefined;
				continue;
			}
			if((i + 1) < listContainer.childElementCount){
				let nextDate = this.getNextEntriesDate(listContainer,i);
				if(nextDate !== undefined){
					if(currentDate === nextDate){
						currentElement.classList.add("_noNextDate");
					}
				}
				if(lastDate !== undefined){
					if(lastDate === currentDate){
						currentElement.classList.add("_noDate");
					}
				}
			}

			if(currentDate !== undefined){
				lastDate = currentDate;
			}
		}
	}

	private removeNoDate(){
		let listContainer = <HTMLElement>document.getElementById("p_schedule_left");
		if(listContainer == null){
			return;
		}
		for(let i = 0; i < listContainer.childElementCount; i++){
			let currentElement = <HTMLElement>listContainer.children.item(i);
			currentElement.classList.remove("_noDate");
			currentElement.classList.add("_noNextDate");
		}
	}

	private getNextEntriesDate(list: HTMLElement, index:number):string|undefined{
		for(let i = index + 1; i < list.childElementCount; i++){
			if(list.children.item(i).classList.contains("_entry")){
				return (list.children.item(i) as HTMLElement).dataset.date;
			}
		}
		return undefined;
	}

	private checkEmptyMonths(){
		var listContainer = <HTMLElement>document.getElementById("p_schedule_left");
		if(listContainer == null){
			return;
		}
		var lastEmptyHeader:null|HTMLElement = null;
		var isEmptyMonth = true;
		for(var i = 0; i < listContainer.childElementCount; i++){
			var currentElement = <HTMLElement>listContainer.children.item(i);
			if(currentElement.classList.contains("_emptyEntry")){
				lastEmptyHeader = currentElement;
			}else if(currentElement.classList.contains("_entry")){
				if(currentElement.style.display === "flex" || currentElement.style.display === "block"){
					isEmptyMonth = false;
				}
			}
			
			if(currentElement.classList.contains("_monthHeader") || (i === (listContainer.childElementCount - 1))){ 
				if(lastEmptyHeader == null){
					continue;
				}
				if(isEmptyMonth){
					lastEmptyHeader.style.display = "block";
				}else{
					lastEmptyHeader.style.display = "none";
				}
				isEmptyMonth = true;
			}

		}

	}
}